import { createTextComponent } from './createTextComponent';

export const BodySmall = createTextComponent({
  styleAs: 'bodySmall',
  tag: 'div',
});
